import _ from 'lodash';
import React, { useMemo } from 'react';
import { MemberFilter } from '~/components';

function ContactFiltersBar({ filters, sticky, onChange }) {
  const visible = useMemo(() => {
    const isVisible = (key) => sticky?.includes(key) || !_.isEmpty(filters[key]);

    return {
      contactOwners: isVisible('contactOwners'),
    };
  }, [filters, sticky]);

  return (
    <>
      {visible.contactOwners && (
        <MemberFilter
          name="contactOwners"
          placeholder="Contact Owner"
          value={filters.contactOwners}
          onChange={({ target: { value } }) => onChange({ contactOwners: value })}
        />
      )}
    </>
  );
}

export default ContactFiltersBar;
